// src/pages/AboutUs.js
import React, { useState, useEffect } from "react";
import "../styles/AboutUs.css";
import missionImage from "../assets/images/mission.png";
import BackToTop from "../components/BackToTop";
import SEO from "../components/SEO";
import api, { API_ENDPOINTS } from "../config/api";

const AboutUs = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await api.get(API_ENDPOINTS.PAGES.ABOUT);
      } catch (error) {
        console.error("Error fetching about us content:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchContent();
  }, []);

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div className="about-us-container">
      <SEO
        title="About Grad4Grad - Your Guide to Studying Abroad"
        description="Learn about Grad4Grad, a free counseling service dedicated to helping students achieve their dreams of studying abroad. Discover our mission, team, and values."
        keywords="about grad4grad, studying abroad, free counseling, international education, education guidance"
      />
      <div className="about-hero">
        <h1>About Grad4Grad</h1>
        <p>
          We are dedicated to helping students achieve their dreams of studying
          abroad through personalized guidance and support.
        </p>
      </div>

      <div className="mission-section">
        <div className="mission-content">
          <h2>Our Mission</h2>
          <p>
            At Grad4Grad, we believe that quality education guidance should be
            accessible to all. Our mission is to empower students with the
            knowledge, resources, and support they need to make informed
            decisions about their international education journey.
          </p>
          <p>
            We are committed to providing completely free counseling services to
            every student, ensuring that financial constraints never stand in
            the way of quality education guidance. Our expert counselors work
            tirelessly to help students navigate the complex process of studying
            abroad, from university selection to visa applications.
          </p>
          <div className="mission-highlights">
            <div className="highlight-item">
              <h3>Free Counseling</h3>
              <p>
                We offer completely free one-on-one counseling sessions to all
                students, with no hidden charges or commitments required.
              </p>
            </div>
            <div className="highlight-item">
              <h3>Expert Guidance</h3>
              <p>
                Our experienced counselors provide personalized guidance on
                university selection, course choices, and application processes.
              </p>
            </div>
            <div className="highlight-item">
              <h3>Comprehensive Support</h3>
              <p>
                From document preparation to visa guidance, we support students
                at every step of their study abroad journey.
              </p>
            </div>
          </div>
          <div className="mission-cta">
            <h3>Start Your Journey Today</h3>
            <p>
              Book your free counseling session and take the first step towards
              your dream education!
            </p>
            <a
              href="https://shorturl.at/uvKtH"
              target="_blank"
              rel="noopener noreferrer"
              className="cta-button"
            >
              Book Free Counseling Session
            </a>
          </div>
        </div>
        <div className="mission-image">
          <img src={missionImage} alt="Our mission at Grad4Grad" />
        </div>
      </div>

      <div className="team-section">
        <h2>Our Team</h2>
        <p className="team-intro">
          Meet our dedicated team of education consultants and counselors who
          are committed to helping students achieve their academic dreams. With
          years of experience in international education, our team provides
          expert guidance and support throughout your study abroad journey.
        </p>
        <div className="team-cta">
          <h3>Get Personalized Guidance</h3>
          <p>
            Our expert counselors are ready to help you navigate your study
            abroad journey. Book your free counseling session today!
          </p>
          <a
            href="https://shorturl.at/uvKtH"
            target="_blank"
            rel="noopener noreferrer"
            className="cta-button"
          >
            Book Free Counseling Session
          </a>
        </div>
      </div>

      <div className="values-section">
        <h2>Our Values</h2>
        <div className="values-grid">
          <div className="value-card">
            <h3>Excellence</h3>
            <p>
              We strive for excellence in everything we do, from the quality of
              our guidance to the support we provide to our students.
            </p>
          </div>
          <div className="value-card">
            <h3>Integrity</h3>
            <p>
              We maintain the highest standards of integrity in our
              relationships with students, universities, and partners.
            </p>
          </div>
          <div className="value-card">
            <h3>Innovation</h3>
            <p>
              We continuously innovate our services and platforms to provide the
              best possible experience for our students.
            </p>
          </div>
          <div className="value-card">
            <h3>Student Success</h3>
            <p>
              We are committed to the success of every student we work with,
              providing personalized support throughout their journey.
            </p>
          </div>
        </div>
      </div>
      <BackToTop />
    </div>
  );
};

export default AboutUs;
